import { render, staticRenderFns } from "./alarmSetting-SIM.vue?vue&type=template&id=66bdb4ea"
import script from "./alarmSetting-SIM.vue?vue&type=script&lang=ts"
export * from "./alarmSetting-SIM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports